const MessageVariant = {
  Warning: 'warning',
  Error: 'error',
};

export default MessageVariant;
